import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, BookOpen, Phone ,Gamepad2} from 'lucide-react';
import { useAuth } from "../context/AuthContext";

const MobileNavigation = () => {
    const location = useLocation();
  const { user: userData } = useAuth();

    const isActive = (path: string) => { 
        return location.pathname === path;
    };
    const hasGamePermissions = userData?.dataUser?.is_venta_juego == 1;

    return (
      // <div className="fixed bottom-0 left-0 right-0 bg-yellow-400 md:hidden no-print z-[40]"></div>
      <div className="fixed bottom-0 left-0 right-0 bg-yellow-400  no-print z-[40]">
        <div className="flex justify-around items-center py-1">
          {/* Inicio */}
          <Link to="/" className="flex flex-col items-center py-1">
            <Home
              className={`w-6 h-6 mb-1 ${
                isActive("/") ? "text-pink-950" : "text-gray-700"
              }`}
            />
            <span
              className={`text-xs font-medium ${
                isActive("/") ? "text-pink-950" : "text-gray-700"
              }`}
            >
              Inicio
            </span>
          </Link>

          {hasGamePermissions && (
            <Link to="/shop" className="flex flex-col items-center py-1">
              <Gamepad2
                className={`w-6 h-6 mb-1 ${
                  isActive("/shop") ? "text-pink-950" : "text-gray-700"
                }`}
              />
              <span
                className={`text-xs font-medium ${
                  isActive("/noticias") ? "text-pink-950" : "text-gray-700"
                }`}
              >
                Tienda de Juegos
              </span>
            </Link>
          )}
          {/* <Link to="/noticias" className="flex flex-col items-center py-1">
            <BookOpen
              className={`w-6 h-6 mb-1 ${
                isActive("/noticias") ? "text-pink-950" : "text-gray-700"
              }`}
            />
            <span
              className={`text-xs font-medium ${
                isActive("/noticias") ? "text-pink-950" : "text-gray-700"
              }`}
            >
              Noticias
            </span>
          </Link> */}

          {/* Teléfono */}
          <Link to="/contacto" className="flex flex-col items-center py-1">
            <Phone
              className={`w-6 h-6 mb-1 ${
                isActive("/contacto") ? "text-pink-950" : "text-gray-700"
              }`}
            />
            <span
              className={`text-xs font-medium ${
                isActive("/contacto") ? "text-pink-950" : "text-gray-700"
              }`}
            >
              Teléfono
            </span>
          </Link>
        </div>

        {/* Safe area spacing for iOS */}
        <div className="h-safe-area bg-yellow-400" />
      </div>
    );
};

export default MobileNavigation;